(() => {
  const desktopQuery = window.matchMedia('(min-width: 1200px)');

  const initNavigation = (navigation) => {
    if (navigation.dataset.mspMegaReady === 'true') return;
    navigation.dataset.mspMegaReady = 'true';

    const menus = [...navigation.querySelectorAll(':scope > [data-msp-mega-menu]')];
    const isDesktopNavigation = navigation.classList.contains('msp-mega-navigation--desktop');
    let closeTimer;

    const syncMenu = (menu) => {
      const trigger = menu.querySelector(':scope > summary');
      trigger?.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    };

    const closeMenu = (menu, restoreFocus = false) => {
      if (!menu.open) return;
      menu.open = false;
      syncMenu(menu);
      if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
    };

    const closeOtherMenus = (activeMenu) => {
      menus.forEach((menu) => {
        if (menu !== activeMenu) closeMenu(menu);
      });
    };

    menus.forEach((menu) => {
      const trigger = menu.querySelector(':scope > summary');
      syncMenu(menu);

      menu.addEventListener('toggle', () => {
        if (menu.open) closeOtherMenus(menu);
        syncMenu(menu);
      });

      trigger?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          menu.open = true;
          closeOtherMenus(menu);
          syncMenu(menu);
          requestAnimationFrame(() => menu.querySelector('.msp-mega-panel a')?.focus());
        }
      });

      trigger?.addEventListener('click', (event) => {
        if (!isDesktopNavigation || !desktopQuery.matches) return;
        event.preventDefault();
        window.clearTimeout(closeTimer);
        closeOtherMenus(menu);
        menu.open = true;
        syncMenu(menu);
      });

      if (isDesktopNavigation) {
        menu.addEventListener('mouseenter', () => {
          if (!desktopQuery.matches) return;
          window.clearTimeout(closeTimer);
          closeOtherMenus(menu);
          menu.open = true;
          syncMenu(menu);
        });
        menu.addEventListener('mouseleave', () => {
          if (!desktopQuery.matches) return;
          closeTimer = window.setTimeout(() => closeMenu(menu), 180);
        });
      }
    });

    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = menus.find((menu) => menu.open);
      if (!openMenu) return;
      event.preventDefault();
      closeMenu(openMenu, true);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = menus.find((menu) => menu.open);
      if (!openMenu) return;
      event.preventDefault();
      closeMenu(openMenu, true);
    });

    document.addEventListener('pointerdown', (event) => {
      if (!navigation.contains(event.target)) menus.forEach((menu) => closeMenu(menu));
    });

    desktopQuery.addEventListener('change', () => menus.forEach((menu) => closeMenu(menu)));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-msp-mega-navigation]').forEach(initNavigation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
